import { makeStyles } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import Container from '@material-ui/core/Container';
import Paper from '@material-ui/core/Paper';
import { Button, Typography } from '@material-ui/core';
import {
	useDeleteAuthorMutation,
	useDeleteCategoryMutation,
	useGetAdminAuthorsQuery,
	useGetAdminCategoriesQuery,
} from '../../../store/apiSlice';
import React, { useRef, useState } from 'react';

import { PageNav } from '../../../components/pageNav';
import { Helmet } from 'react-helmet-async';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import AddIcon from '@material-ui/icons/Add';

import { Skeleton } from '@material-ui/lab/';
import { Link } from 'react-router-dom';

const useStyles = makeStyles((theme) => ({
	root: {
		display: 'flex',
		alignItems: 'center',
	},
	container: {
		paddingTop: theme.spacing(4),
		paddingBottom: theme.spacing(4),
	},
	paper: {
		padding: theme.spacing(2),
	},
	title: {
		paddingBottom: theme.spacing(2),
	},
	table: {
		minWidth: 650,
	},
	grid: {
		borderColor: theme.palette.secondary,
		borderBottom: '1px solid',
		marginTop: theme.spacing(1),
	},
	flex: {
		display: 'flex',
		flexDirection: 'column',
		flexWrap: 'wrap',
		gap: theme.spacing(1),
	},
}));

export function Categories() {
	const classes = useStyles();
	const [pageInput, setPageInput] = useState(1);

	const { data: categoryData, isFetching } = useGetAdminCategoriesQuery({
		page: pageInput,
	});

	const firstResultRef = useRef(null);

	const handlePageMove = (sign) => () => {
		setPageInput((prevState) => prevState + 1 * sign);
	};

	const handleInputChange = (e) => {
		e.persist();
		const newValue = Math.min(
			Math.max(e.target.value, 1),
			categoryData?.pageCount || pageInput
		);
		setPageInput(newValue);
	};

	let categories = categoryData?.categories || Array.from({ length: 20 });

	const [deleteAuthor, result] = useDeleteCategoryMutation();
	const handleDeleteCurry = (id) => {
		const handleDelete = (e) => {
			deleteAuthor({ id });
		};

		return handleDelete;
	};

	return (
		<div className={classes.root}>
			<CssBaseline />
			<Helmet>
				<title>Категории</title>
			</Helmet>

			<Container maxWidth="lg" className={classes.container}>
				<Paper className={classes.paper}>
					<Typography
						className={classes.title}
						component="h1"
						variant="h4"
						role="alert"
					>
						Категории
					</Typography>
					<Link to={'/admin/categories/create'}>
						<Button className={classes.paper} startIcon={<AddIcon />}>
							Добави
						</Button>
					</Link>
					<TableContainer component={Paper}>
						<Table className={classes.table} aria-label="Моите книги">
							<TableHead>
								<TableRow>
									<TableCell>Категория</TableCell>
									<TableCell>Операция</TableCell>
								</TableRow>
							</TableHead>
							<TableBody>
								{categories.map((category, index) => (
									<TableRow key={index}>
										<TableCell scope="row">
											{!isFetching ? (
												<Link
													ref={firstResultRef}
													to={`/admin/categories/${category?.id}`}
													state={{ name: category?.name }}
												>
													{category?.name}
												</Link>
											) : (
												<Skeleton width={'25vw'} />
											)}
										</TableCell>
										<TableCell align="left">
											<Link
												ref={firstResultRef}
												to={`/admin/categories/${category?.id}`}
												state={{ name: category?.name }}
											>
												<Button startIcon={<EditIcon />}></Button>
											</Link>
											<Button
												startIcon={<DeleteIcon />}
												onClick={handleDeleteCurry(category?.id)}
											></Button>
										</TableCell>
									</TableRow>
								))}
							</TableBody>
						</Table>
					</TableContainer>
					{categories.length ? (
						<PageNav
							isFetching={isFetching}
							maxPage={categoryData?.pageCount}
							handlePageMove={handlePageMove}
							pageInput={pageInput}
							handleInputChange={handleInputChange}
						/>
					) : (
						<Typography>Няма намерени книги.</Typography>
					)}
				</Paper>
			</Container>
		</div>
	);
}
